import React, { useContext } from 'react';
import { Container, Typography, Button, Box } from '@mui/material';
import { UserContext } from '../context/UserContext';

const AccountReviewPage = () => {
  const { logout } = useContext(UserContext);

  const handleContactClick = () => {
    window.location.href = 'mailto:support@techxpander.com';
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <Container
      maxWidth='sm'
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: 0,
        flexGrow: 1,
        textAlign: 'center',
      }}
    >
      <Typography variant='h4' mb={4}>
        Your account is under review
      </Typography>
      <Box mb={2}>
        <Typography variant='body1'>
          Thanks for signing up. Your account is not active yet. TechXpander first reviews and approves each new Lead
          Agent.
        </Typography>
      </Box>
      <Box mb={2}>
        <Typography variant='body1'>You’ll get access to the platform once your account is approved.</Typography>
      </Box>
      <Box mb={2}>
        <Typography variant='body1'>If you believe this is a mistake or have questions, please contact us.</Typography>
      </Box>
      <Box mb={2} display='flex' alignItems='center' gap={2}>
        <Button variant='contained' color='primary' onClick={handleContactClick}>
          Contact Support
        </Button>
        <Button variant='contained' color='error' onClick={handleLogout}>
          Logout
        </Button>
      </Box>
    </Container>
  );
};

export default AccountReviewPage;
